<template>
  <div>
    <el-form
      v-if="!isSubscribed"
      ref="form"
      :model="user"
      :rules="rules"
      :show-message="false"
      :status-icon="true"
      class="subscribe-form small"
      @submit.native.prevent="didTapLetsGo"
    >
      <el-row
        :gutter="12"
        type="flex"
        align="bottom"
        class="flex-wrap">
        <el-col
          :md="18"
          :sm="18"
          :xs="24">
          <el-form-item
            label="Email Address"
            prop="email"
          >
            <el-input
              v-model="user.email"
              data-test="input-subscribe"
              placeholder="Enter your email"
              @input="mp_error = null"
            />
          </el-form-item>
        </el-col>
        <el-col
          :md="6"
          :sm="6"
          :xs="24"
          class="t-c">
          <el-button
            v-loading="loading"
            data-test="btn-subscribe"
            type="primary"
            @click="didTapLetsGo"
          >
            Submit
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <div
      v-if="isSubscribed"
      class="subs-thanks"
      data-test="subs-thanks"
    >
      <strong>Thanks!</strong> We'll be in touch soon.
    </div>
  </div>
</template>

<script>
import User from '../../services/User';

export default {
  data() {
    return {
      user: {
        email: '',
      },
      userProvider: new User(),
      // mp_error: null,
      subscribed: false,
      isSubscribed: false,
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: 'Email is required',
            trigger: 'change',
          },
          {
            type: 'email',
            // message: 'Please enter a valid email address',
            trigger: 'change',
          },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // const isSubscribedToMailchimp = localStorage.getItem('is_subscribed_to_mailchimp');
      this.user.email = '';
      this.subscribed = false;
      // this.isSubscribed = isSubscribedToMailchimp;
      this.mp_error = null;
    },
    didTapLetsGo() {
      const { country } = this.$store.getters;
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            email: this.user.email, newsletter: 'YES', country,
          };
          // check international
          if (!this.supportedCountries.includes(country)) {
            params.intl = 'YES';
          }
          if (window.analytics && window.analytics.user()) {
            const anonymouseId = window.analytics.user().anonymousId();
            this.$analytics.identify(anonymouseId, params);
          }

          const userData = this.$store.getters.user || {};
          userData.email = this.user.email;
          this.$store.commit('setUser', userData);
          // localStorage.setItem('is_subscribed_to_mailchimp', true);
          this.isSubscribed = true;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.subscribe-form {
  h3 {
    margin-bottom: 25px;
  }

  button {
    padding: 15px 35px;
    font-size: 18px;

    @media (max-width: 768px) {
      margin-top: 20px;
    }

    @media (max-width: 567px) {
      margin-top: 0;
    }
  }

  .el-form-item {
    margin-bottom: 0px;
    input{
      height: 48px;
    }
  }
}
@media (max-width: 567px) {
  .subscribe-form {
    .el-form-item {
      margin-bottom: 22px;
    }
  }
}
.subs-thanks{
  font-size: 22px;
  line-height: 32px;
  margin-top: 28px;
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/SubscribeForm.vue